import angular from 'angular';
import sidemenuComponent from './sidemenu.component';
import sidemenuButtonComponent from './sidemenu-button.component';
import sidemenuItemComponent from './sidemenu-item.component';
import sidemenuSubmenuComponent from './sidemenu-submenu.component';
import sidemenuButtonSubmenuComponent from './sidemenu-button-submenu.component';

let sidemenuModule = angular.module('sidemenu', [
])
    .component('sidemenu', sidemenuComponent)
    .component('sidemenuItem', sidemenuItemComponent)
    .component('sidemenuButton', sidemenuButtonComponent)
    .component('sidemenuSubmenu', sidemenuSubmenuComponent)
    .component('sidemenuButtonSubmenu', sidemenuButtonSubmenuComponent)
.name;

export default sidemenuModule;
